// test903
(903 && 0);
